import { MdFlightTakeoff, MdGavel, MdPayments } from 'react-icons/md';
import './HowItWorks.css';

const STEPS = [
  {
    icon: <MdFlightTakeoff />,
    step: '01',
    title: 'Enter your flight details',
    desc: 'Tell us your departure airport, destination, and flight date. Takes under 2 minutes.',
    color: '#1e40af',
    bg: '#eff6ff',
  },
  {
    icon: <MdGavel />,
    step: '02',
    title: 'We check your eligibility',
    desc: 'Our legal team scans EU261, UK261, and international regulations to assess your claim instantly.',
    color: '#16a34a',
    bg: '#f0fdf4',
  },
  {
    icon: <MdPayments />,
    step: '03',
    title: 'You receive your payout',
    desc: 'We handle all negotiations with the airline. You get paid up to $650,  no win, no fee.',
    color: '#1e40af',
    bg: '#eff6ff',
  },
];

export default function HowItWorks() {
  return (
    <section className="hiw">
      <div className="hiw__inner">

        {/* ── Left: steps ── */}
        <div className="hiw__left">
          <span className="hiw__tag">How it works</span>
          <h2 className="hiw__title">Three simple steps to your compensation</h2>
          <p className="hiw__sub">No upfront cost. No legal knowledge needed. We handle everything.</p>

          <div className="hiw__steps">
            {STEPS.map(({ icon, step, title, desc, color, bg }, i) => (
              <div key={step} className="hiw__step">
                {/* connector line */}
                {i < STEPS.length - 1 && <div className="hiw__connector" />}

                <div className="hiw__step-icon" style={{ background: bg, color }}>
                  {icon}
                </div>

                <div className="hiw__step-body">
                  <span className="hiw__step-num" style={{ color }}>{step}</span>
                  <h3 className="hiw__step-title">{title}</h3>
                  <p className="hiw__step-desc">{desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── Right: image ── */}
        <div className="hiw__right">
          <div className="hiw__img-wrap">
            <img
              src="https://images.unsplash.com/photo-1542296332-2e4473faf563?w=900&q=80&auto=format&fit=crop"
              alt="Passenger at airport checking flight information"
              className="hiw__img"
            />
            {/* Floating badge */}
            <div className="hiw__badge">
              <span className="hiw__badge-icon">✓</span>
              <div>
                <strong>98% success rate</strong>
                <span>on all submitted claims</span>
              </div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
}